import request from '@/utils/request'

// 增加测试imei
let addTestIMEI=(data)=>request.post('/api/test/addTestImei',data,{'content-type':'multipart/form-data'})
// 搜索测试imei
let searchTestIMEI=(data)=>request.get('/api/test/searchImei',data)
// 删除测试imei
let delTestIMEI=(data)=>request.post('/api/test/deleteTestImei',data,{'content-type':'multipart/form-data'})

export default {
    addTestIMEI,
    searchTestIMEI,
    delTestIMEI,
}